import { Alert, Box, Button, Typography } from '@mui/material';
import React from 'react';
import { Amount } from '@shared/components/styled/amount';
const Intro = (props) => {
    return (React.createElement(Box, { sx: { display: 'flex', flexDirection: 'column', gap: 2 } },
        React.createElement(Box, null,
            React.createElement(Alert, { severity: 'info', variant: 'outlined', icon: false },
                React.createElement(Typography, { variant: 'subtitle2', fontWeight: 'bold' }, "Why is verification required?"),
                React.createElement(Typography, { variant: 'caption' }, "To comply with anti-money laundering regulations and maintain the security of our platform, we need to verify the originator of this crypto deposit."))),
        React.createElement(Box, { sx: { display: 'flex', flexDirection: 'column' } },
            React.createElement(Box, { sx: { display: 'flex', justifyContent: 'space-between' } },
                React.createElement(Typography, { variant: 'body2' }, "Transaction ID"),
                React.createElement(Typography, { maxWidth: 100, sx: { textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' } },
                    React.createElement(Amount, null, props.deposit.compliance_tx_hash))),
            React.createElement(Box, { sx: { display: 'flex', justifyContent: 'space-between' } },
                React.createElement(Typography, { variant: 'body2' }, "Amount"),
                React.createElement(Typography, null,
                    React.createElement(Amount, null, props.deposit.compliance_amount),
                    " ",
                    props.deposit.currency_ticker)),
            React.createElement(Box, { sx: { display: 'flex', justifyContent: 'space-between' } },
                React.createElement(Typography, { variant: 'body2' }, "Destination Wallet"),
                React.createElement(Typography, { maxWidth: 100, sx: { textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' } },
                    React.createElement(Amount, null, props.deposit.wallet_code)))),
        React.createElement(Button, { variant: 'contained', fullWidth: true, onClick: () => {
                props.onNext();
            } }, "Start Verification"),
        React.createElement(Button, { variant: 'outlined', fullWidth: true, onClick: () => {
                props.onClose();
            } }, "Cancel")));
};
export default Intro;
